import { useState, useEffect } from 'react'
import axios from 'axios'
import { comparer } from '../../utils/comparer'
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router'
import { useToast } from '../../toastHook'
import { displayErrors } from '../Utils/formik-util';
import { errorCss } from '../Utils/formik-util';

const ListBoxComponent = ({ source, target, setTarget}) => {

    const [toAdd, setToAdd]= useState()

    const addTarget = () => {
        if (!target || !toAdd || target.find(x => x === toAdd)) {
            return;
        }

        var newTarget = [...target, toAdd];
        newTarget.sort(comparer);

        setTarget(newTarget);
    }

    const removeTarget = row => {
        setTarget(target.filter(x => x !== row));
    }


    return <div>
    <div className="d-flex gap-3">
        <Dropdown value={toAdd} onChange={e => setToAdd(e.value)} placeholder="ajouter un élément" options={source} optionLabel="value" filter />
            <button type="button" className="btn btn-success" onClick={ addTarget } ><i className="pi pi-plus" ></i></button>
        </div>
        <ul className="list-group mt-4">
            {target.map(row => <li className="list-group-item d-flex justify-content-between" key={row} ><span >{row}</span> <i className="pi pi-times-circle text-danger" onClick={() => removeTarget(row)}></i></li>) }
        </ul>
    </div>
}


export const MergeCompetenceDeterminanteComponent = () => {

    const { display } = useToast();
    const navigate = useNavigate();
    const [competences, setCompetences] = useState([]);
    const [activites, setActivites] = useState();

    useEffect(() => {
        axios.get('/api/competences/get').then(response => {
            let tmpCompetences = response.data.map(x => { return { value: x } }
            );
            tmpCompetences.sort((x, y) => comparer(x.value, y.value));
            setCompetences(tmpCompetences)
        })
    }, []);

    useEffect(() => {
        axios.get('/api/activite/getall').then(
            response => {
                let tmpActivites = response.data.map(x => { return { value: x } }
                );
                tmpActivites.sort((x, y) => comparer(x.value, y.value));
                setActivites(tmpActivites)
            });
    }, []);
    const formikSchema = Yup.object().shape({
        activites: Yup.array().min(1, "les activités ne doivent pas être vides"),
        competences: Yup.array().min(1,"les compétences ne doivent pas être vides"),
        priorite: Yup.number().integer().min(0, 'priorité doit être supérieur à 0').max(100, 'priorité doit être inférieur à 100').required('priorité est requis')
    })

    const mergeFormik = useFormik({
        initialValues: {
            activites: [],
            competences: [],
            priorite: ''
        },
        validationSchema: formikSchema,
        onSubmit: values => {

            var toSend = [];

            for (var i = 0; i < values.competences.length; ++i)
                for (var j = 0; j < values.activites.length; ++j) {
                    toSend.push({
                        competence: values.competences[i],
                        activite: values.activites[j],
                        priorite: values.priorite

                    })
                }
   
            axios.post('/api/competencedeterminante/merge', toSend).then(response => {
                if (response.status === 200) {

                    display({
                        titre: 'compétences déterminantes ajoutées en bloc',
                        text: 'les compétences déterminantes ont été ajoutées en blocs',
                        severity: 'success'
                    });

                    navigate("/config/competencedeterminante");
                }
                else {
                    display({
                        titre: "compétences déterminantes n'ont pas pu être ajoutées en bloc",
                        text: "les compétences déterminantes n'ont pas pu être ajoutées en blocs",
                        severity: 'danger'
                    });
                }
            });
        }
    });

    return <div>
        <div className="alert alert-primary">Cet écran vous permet de créer en masse (ou mettre à jour des compétences déterminantes)</div>
        <form onSubmit={mergeFormik.handleSubmit}>
            { displayErrors(mergeFormik) }
        <div className="row mt-4">
            <div className="col-5">
                <h3>Compétences</h3>
                <ListBoxComponent source={competences} target={mergeFormik.values.competences} setTarget={ x =>  mergeFormik.setFieldValue("competences", x) } ></ListBoxComponent>
            </div>
            <div className="col-2">
                    <h3>Priorité</h3>
                    <div className="form-group">
                        <input name="priorite" onChange={mergeFormik.handleChange}
                            value={mergeFormik.values.priorite} type="text" id="priorite" className={`form-control ${errorCss(mergeFormik.errors.priorite)}`}></input>
                        {mergeFormik.errors.priorite ? (
                            <div className="invalid-feedback">{mergeFormik.errors.priorite}</div>
                        ) : (<></>)}
                    </div>
            </div>
            <div className="col-5">
                <h3>Activités</h3>
                <ListBoxComponent source={activites} target={mergeFormik.values.activites} setTarget={x => mergeFormik.setFieldValue("activites", x)} ></ListBoxComponent>
            </div>
            </div>
            <div className="text-center mt-4"><button type="submit" className="btn btn-success"  >Ajouter tout</button></div>
        </form>
    </div>
}


